<template>

	<div class="product-single--wrapper">
		<div class="product-single-main">
			<div class="product-added--overlay" v-show="itemAdded">
				<div class="container">
					<div class="product-added--overlay-wrapper">
						<img src="/images/icons/ic-notification.svg" alt="Notification" title="Notification" class="icon">
						<p><span v-text="productName"></span>&nbsp;-&nbsp;<strong v-text="$__('cart.added')"></strong> <button class="btn btn-sm btn-primary btn-view-cart" @click="showCart" v-text="$__('cart.view')"></button></p>
						<button class="btn btn-plain btn-close" @click="addedClose">
							<svg slot="close" class="ticon"><use xlink:href="/images/icons.svg#icon-close"></use></svg>
						</button>
					</div>
				</div>
			</div>
			<div class="product-single--prices" v-if="buy_type === 0">
				<span v-if="discountPrice != mainPriceRegular">
					<span class="product-single--price" v-html="discountPrice"></span>
					<span class="ml-2 font-weight-bold"><del class="text-muted">{{ mainPriceRegular }}</del></span>
				</span>
				<span v-else class="product-single--price" v-html="mainPriceRegular"></span>

				<span class="product-single--stock stock" v-if="stock === 1" v-text="$__('cart.in_stock')"></span>
				<span class="product-single--stock" v-else v-text="$__('cart.out_of_stock')"></span>
			</div>
			<div class="product-single--desc">
				<p v-html="lead"></p>
			</div>

			<div class="product-single--togglers">
				<validationObserver ref="observer" v-slot="{ invalid }" tag="form" @submit.prevent="addToCart">
				<div class="btn-group btn-group-toggle d-flex flex-wrap mb-md-4 mb-3" data-toggle="buttons">

					<ValidationProvider
						rules="is_not:choose"
						v-slot="{ errors }"
						class="input-name input-options"
						tag="div"
						v-if="lengths && Object.keys(lengths).length !== 0"
					>

						<select v-if="lengths && Object.keys(lengths).length !== 0" v-model="length" :class="{ 'input-error is-invalid': errors.length }" id="variation-select" class="custom-select">
							<option value="choose">{{ $__('cart.choose.option') }}</option>
							<option v-for="(length_value,index) in lengths" :key="index" :value="index" v-text="length_value" class="selection-item"></option>
						</select>
						<div v-if="errors.length" class="invalid-feedback">
							{{ errors[0] }}
						</div>

					</ValidationProvider>

					<label class="btn btn-outline-secondary" :class="{ active: product_id === variant.id }" v-for="variant in variants">
						<input type="radio" v-model="product_id" :value="variant.id" autocomplete="off" @change="changeExtension(variant)"> <span v-text="variantTitle(variant)"></span>
					</label>

				</div>

				<div class="product-single--add" v-if="buy_type === 0 && stock > 0">
					<div class="product-single--quantity">
						<span class="qty" v-text="$__('cart.quantity')"></span>
						<vue-numeric-input
							v-model="amount"
							:min="1"
							:max="99"
							:step="1"
							size="120px"
							align="center"
						></vue-numeric-input>
					</div>
					<button type="submit" class="btn btn-lg btn-primary" v-text="$__('cart.product.add.to.cart')"></button>
				</div>

				<div class="product-single--add" v-if="buy_type === 0 && stock === 0"></div>

				<div class="product-single--add" v-if="buy_type !== 0">
					<button @click.prevent="requestQuote" class="btn btn-lg btn-primary" v-text="$__('cart.product.request.quote')"></button>
				</div>

				</validationObserver>

				<div class="pt-2 text-right">
					<small>We accept following payments<br></small>
					<img src="/images/payments.svg" class="img-fluid" />
				</div>
			</div>

			<div class="recommended" v-if="length !== 'choose' && length > 1 && this.extensions.length > 0">
				<p class="label" v-text="$__('cart.recommended_extensions')"></p>
				<p class="label-sub">add to cart with a <svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-plus-circle"></use></svg></p>
				<div class="recommended-element" v-for="(extension,index) in this.extensions" v-show="length - 2 === index">
					<img  loading="lazy" :src="extension.picture" :title="extension.seo_title" :alt="extension.seo_title">
					<p class="desc">{{ extensionTitle(extension) }}</p>
					<div class="quantity">
						<vue-numeric-input
							v-model="amount2"
							:min="1"
							:max="99"
							:step="1"
							size="120px"
							align="center"
						></vue-numeric-input>
					</div>
					<div class="add">
						<button @click.prevent="addToCartExtension(extension)" class="btn btn-plain">
							<svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-plus-circle"></use></svg>
						</button>
					</div>
				</div>
			</div>

		</div>

		<div  v-if="recommended" class="recommended">
			<p class="label" v-text="$__('cart.recommended_product')"></p>
			<p class="label-sub">{{ $__('cart.add_hint') }} <svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-plus-circle"></use></svg></p>
			<div class="recommended-element">
				<img  loading="lazy" :src="recommended.picture" :title="recommended.seo_title" :alt="recommended.seo_title">
				<p class="desc">{{ recommendedTitle }}</p>
				<div class="quantity">
					<vue-numeric-input
						v-model="amount3"
						:min="1"
						:max="99"
						:step="1"
						size="120px"
						align="center"
					></vue-numeric-input>
				</div>
				<div class="add">
					<button @click.prevent="addToCartRecommended" class="btn btn-plain">
						<svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-plus-circle"></use></svg>
					</button>
				</div>
			</div>
		</div>

		<div v-if="recommended_products.length || Object.keys(recommended_products).length" class="recommended">
			<p class="label" v-text="$__('cart.recommended_products')"></p>
			<p class="label-sub">{{ $__('cart.add_hint') }} <svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-plus-circle"></use></svg></p>
			<div class="recommended-element" v-for="recommended_product, index in recommended_products">
				<img  loading="lazy" :src="recommended_product.picture" :title="recommended_product.seo_title" :alt="recommended_product.seo_title">
				<p v-if="recommended_product.price_discount && recommended_product.price_discount > 0" class="desc">
					<a :href="recommended_product.slug" :title="recommended_product.title" :data-eec-select-item="JSON.stringify(recommendedEecItems[recommended_product.id])">{{  recommendedProductTitle(recommended_product) }}</a><br>({{ formatPrice((recommended_product.locale_price.price * (100 - recommended_product.price_discount) / 100)) }}&nbsp;<del class="text-muted">{{ formatPrice(recommended_product.locale_price.price || recommended_product.price) }}</del> ) <span class="tag-small-discount" v-if="recommended_product.price_discount && recommended_product.price_discount > 0">-{{ parseInt(recommended_product.price_discount) }}%</span>
				</p>
				<p v-else class="desc">
					<a :href="recommended_product.slug" :title="recommended_product.title" :data-eec-select-item="JSON.stringify(recommendedEecItems[recommended_product.id])">{{  recommendedProductTitle(recommended_product) }}</a> ({{ formatPrice(recommended_product.locale_price.price || recommended_product.price) }})
				</p>
				<div class="quantity">
					<vue-numeric-input
						v-model="amount4[index]"
						:value="1"
						:min="1"
						:max="99"
						:step="1"
						size="120px"
						align="center"
					></vue-numeric-input>
				</div>
				<div class="add">
					<button @click.prevent="addToCartRecommendedProducts(recommended_product, index)" class="btn btn-plain">
						<svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-plus-circle"></use></svg>
					</button>
				</div>
			</div>
		</div>

		<div class="product-single--togglers-modal" v-if="modalShown">
			<div class="togglers-modal-wrapper">
				<button class="btn btn-plain btn-close" @click="showModal">
					<span v-text="$__('cart.close')"></span>
					<svg class="ticon ticon-180"><use xlink:href="/images/icons.svg?v1.3#icon-close"></use></svg>
				</button>
				<p class="intro" v-text="$__('cart.add_warning')"></p>
				<div class="options-wrapper">
					<div class="checkbox-options btn-group btn-group-toggle">
						<label class="btn btn-outline-secondary" :class="{ active: product_id === variant.id }" v-for="variant in variants">
							<input type="radio" v-model="product_id" :value="variant.id" autocomplete="off"> <span v-text="variantTitle"></span>
						</label>
					</div>

					<div class="select-options" v-if="lengths">
						<select class="custom-select" id="variation-select-2" v-model="length">
							<option value="" data-placeholder>{{ $__('cart.choose.option') }}</option>
							<option v-for="(length_value,length_key) in lengths" :value="length_key" v-text="length_value"></option>
						</select>
					</div>
				</div>


				<div class="product-single--add" v-if="buy_type === 0">
					<button @click.prevent="addToCart" class="btn btn-lg btn-primary" v-text="$__('cart.product.add.to.cart')"></button>
				</div>

				<div class="product-single--add" v-else>
					<button @click.prevent="requestQuote" class="btn btn-lg btn-primary" v-text="$__('cart.product.request.quote')"></button>
				</div>
			</div>
		</div>
		<div class="product-single--togglers-bottom" v-if="showBar && buy_type === 0 && stock > 0">
			<div class="container">
				<div class="togglers-bottom-wrapper">
					<div class="product-info">
						<img :src="product_thumb" :alt="title">
						<p v-text="title"></p>
					</div>
					<div class="product-options">
						<div class="product-single--quantity">
							<span class="qty" v-text="$__('cart.add.quantity')"></span>
							<vue-numeric-input
								v-model="amount"
								:min="1"
								:max="99"
								:step="1"
								size="120px"
								align="center"
							></vue-numeric-input>

						</div>

						<p v-if="discountPrice != mainPriceRegular" class="price">
							<span v-html="discountPrice"></span>
							<span><del class="text-muted">{{ mainPriceRegular }}</del></span>
						</p>
						<p v-else class="price" v-html="mainPriceRegular"></p>

<!--						<p class="price" v-text="this.formatPrice(current_price)"></p>-->

						<button class="btn btn-primary next-step" @click="scrollInto"><span class="text">{{ $__('cart.add_to_bag') }}</span> <span class="icon"><svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-shopping-bag"></use></svg></span></button>
					</div>
				</div>
			</div>
		</div>

	</div>

</template>
<script>
	import VueNumericInput from 'vue-numeric-input';
	import numbro from "numbro";
	import ContactForm from "../Form/ContactForm";
	import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate';
	import { required, email, is_not } from 'vee-validate/dist/rules';

	extend('is_not', {
	...is_not,
	message: 'This field is required',
	});

	export default {
		name: 'CartAdd',
		components: {
			VueNumericInput,
			ContactForm,
			ValidationObserver,
			ValidationProvider
		},
		props: {
			product: {
				type: Number,
				required: true
			},
			price: {
				type: Number,
				required: true
			},
			price_regular: {
				type: Number,
				required: true
			},
			discount: {
				type: Number,
				required: true
			},
			discount_price: {
				type: Number,
			},
			stock: {
				type: Number,
				required: true
			},
			discounts: {
				type: Object,
				default: () => ({})
			},
			title: {
				type: String,
				required: true
			},
			lead: {
				type: String
			},
			variants: {
				type: Object|Array,
				default: () => ({})
			},
			lengths: {
				type: Object|Array,
				default: () => ({})
			},
			extension: {
				type: Object|Array,
				default: () => ({})
			},
			extensions: {
				type: Object|Array,
				default: () => ({})
			},
			recommended: {
				type: Object|Array,
				default: () => ({})
			},
			recommended_products: {
				type: Object|Array,
				default: () => ({})
			},
			recommendedEecItems: {
				type: Object|Array,
				default: () => ({})
			},
			variant_extensions: {
				type: Object|Array,
				default: () => ({})
			},
			checkout: {
				type: String
			},
			buy_type: {
				type: Number
			},
			product_thumb: {
				type: String|Boolean,
			},
			region_id:{
				type: Number,
			},
			item: {
				type: Object|Array,
				default: () => ({})
			},
			affiliate: {
				type: String
			},
			showBar: {
				type: Boolean,
				default: true
			}
		},
		data () {
			return {
				amount: 1,
				amount2: 1,
				amount3: 1,
				amount4: {},
				product_id: null,
				products: {},
				length: 'choose',
				productName: "",
				itemAdded: false,
				modalShown: false,
				error: false,
				recommendedExtensions: this.extensions,
				current_price: this.price_regular
			}
		},
		computed: {
			recommendedTitle (){
				if(!this.recommended) return '';
				if(this.recommended && this.recommended.locale_price){
					return this.recommended.locale_price.title;
				}else {
					return this.recommended?.title;
				}
			},

			mainPrice () {
				if (this.amount == 1) {
					return this.formatPrice(this.price)
				} else {
					return this.formatPrice(this.discounts[this.amount].price * this.amount);
				}
			},
			mainPriceRegular () {
				let variant = this.variants.find(el => el.id == this.product_id)
				if (variant) {
					if (variant.locale_price) {
						return this.formatPrice(variant.locale_price.price);
					}
					return this.formatPrice(variant.price);
				}
				return this.formatPrice(this.current_price)
			},
			discountPrice () {
				let variant = this.variants.find(el => el.id == this.product_id)
				if (variant) {
					if (variant.discount_price) {
						return this.formatPrice(variant.discount_price);
					}
					return this.formatPrice(variant.price);
				} else if (this.discount_price) {
					return this.formatPrice(this.discount_price)
				}
				return this.formatPrice(this.current_price)
			},
			eventPrice () {
				let variant = this.variants.find(el => el.id == this.product_id)
				if (variant) {
					if (variant.discount_price) {
						return variant.discount_price.toFixed(2).toString()
					}
					return variant.price.toFixed(2).toString()
				} else if (this.discount_price) {
					return this.discount_price.toFixed(2).toString()
				}
				return this.current_price.toFixed(2).toString()
			},
			eventRegularPrice () {
				let variant = this.variants.find(el => el.id == this.product_id)
				if (variant) {
					return variant.price.toFixed(2).toString()
				}
				return this.current_price.toFixed(2).toString()
			}
		},
		watch: {
			amount (val) {
				this.$store.dispatch('cart/setCurrent', {
					length: this.length,
					amount: this.amount,
					id: this.product_id
				});
				this.products = _.pick(this.products, _.range(1, val + 1));

				let previous_options = null;
				for(let i = 1; i <= val; i++) {
					if (!this.products[i]) {
						this.$set(this.products, i, previous_options ? previous_options : parseInt(Object.keys(this.variants).length ? Object.keys(this.variants)[0] : this.product));
					} else {
						previous_options = this.products[i];
					}
				}
			},
			length(val) {
				this.$store.dispatch('cart/setCurrent', {
					length: this.length,
					amount: this.amount,
					id: this.product_id
				});
			}
		},
		methods: {
			extensionTitle (extension){
				if(!extension) return '';
				if(extension && this.extension.locale_price){
					return extension.locale_price.title;
				}else {
					return extension.title;
				}
			},

			variantTitle (variant){
				if(!variant) return '';
				if(variant && variant.locale_price){
					return variant.locale_price.title;
				}else {
					return variant.title;
				}
			},

			recommendedProductTitle(recommended_product){
				if(!recommended_product) return '';
				if(recommended_product.locale_price){
					return recommended_product.locale_price?.title||recommended_product?.title;
				}else {
					return recommended_product.title;
				}
			},
			changeExtension(variant) {
				if (variant.id !== undefined) {
					this.recommendedExtensions = this.variant_extensions[variant.id];
					if (variant.prices.length === 0 ) {
						this.current_price = variant.price
					} else {
						let region_price = variant.prices.find(x => x.region_id == this.region_id);
						if (region_price) {
							this.current_price = region_price.price
						}
					}
				}
			},
			async requestQuote() {
				// this.itemAdded = true;
				// this.productName = this.title;

				// this.$store.dispatch('cart/addToCart', {
				// 	product: this.product_id,
				// 	amount: this.amount
				// }).then(res => {

				// });
				const isValid = await this.$refs.observer.validate();
				if (!isValid) {
					return false;
				}
				this.$root.$refs.ContactForm.requestQuoteShow(this.lengths[this.length] ?? '', this.variants.find(variant => variant.id === this.product_id));
			},
			scrollInto() {
				window.scrollTo({ top: 0, left: 0, behavior: 'smooth'});
				this.addToCart()
			},
			showCart() {
				this.$root.$refs.CartHeader.openCart();
			},
			addedClose () {
				this.itemAdded = false;
			},
			async addToCart() {
				const isValid = await this.$refs.observer.validate();
				if (!isValid) {
					console.log('false');
					return false;
				}
				this.itemAdded = true;
				this.productName = this.title;
				this.error = false;

				this.$store.dispatch('cart/addToCart', {
				product: this.product_id,
				amount: this.amount
				}).then(res => {
					this.$emit('product-added')

					try {
						let full_product_title = this.product_id && this.variants.length && this.variants.find(v => v.id === this.product_id)
							? this.title + ' ' + this.variants.find(v => v.id === this.product_id).title
							: this.title;
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							'event': 'addToCart',
							'ecommerce': {
								'currencyCode': current_currency,
								'add': {
									'products': [{
										'name': full_product_title,
										'id': this.product_id.toString(),
										'price': this.eventPrice,
										'quantity': this.amount
									}]
								}
							}
						});

						// Red Orbit Events
						let variant_name = this.product_id && this.variants.length && this.variants.find(v => v.id === this.product_id)
							? this.title + ' ' + this.variants.find(v => v.id === this.product_id).title
							: undefined;
						window.dataLayer.push({'event_params': null, 'ecommerce': null});
						window.dataLayer.push({
							'event': 'RO_event_EEC',
							'event_params': {
								'gtm_name': 'EEC_add_to_cart',
							},
							'ecommerce': {
								'currency': global.current_currency,
								'items': [{
									'item_id': this.product_id.toString(),
									'item_name': this.title,
									'item_variant': variant_name ? variant_name : undefined,
									'item_brand': 'Lupit Pole',
									'item_category': this.item.category.parent_category.title ? this.item.category.parent_category.title : this.item.category_title,
									'item_category2': this.item.category.parent_category.title ? this.item.category.title : undefined,
									'price': this.eventPrice,
									'discount': parseFloat(this.eventRegularPrice - this.eventPrice),
									'affiliation': this.affiliate ? this.affiliate : undefined,
									'quantity': this.amount
								}]
							},
						});

					} catch (e) {}

				});
			},

			addToCartExtension (extension) {
				this.itemAdded = true;
				this.productName = extension.title;
				this.$store.dispatch('cart/addToCart', {
					product: extension.id,
					amount: this.amount2
				}).then(res => {

				});
			},
			addToCartRecommended () {
				this.itemAdded = true;
				this.productName = this.recommended.title;

				this.$store.dispatch('cart/addToCart', {
					product: this.recommended.id,
					amount: this.amount3
				}).then(res => {

					// Red Orbit Events
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({'event_params': null, 'ecommerce': null});
					window.dataLayer.push({
						'event': 'RO_event_EEC',
						'event_params': {
							'gtm_name': 'EEC_add_to_cart',
						},
						'ecommerce': {
							'currency': global.current_currency,
							'items': [{
								'item_id': this.recommended.id.toString(),
								'item_name': this.recommended.title,
								'item_variant': undefined,
								'item_brand': 'Lupit Pole',
								// 'item_category': this.item.category.parent_category.title ? this.item.category.parent_category.title : this.item.category_title,
								// 'item_category2': this.item.category.parent_category.title ? this.item.category.title : undefined,
								// 'price': this.eventPrice,
								// 'discount': parseFloat(this.eventRegularPrice - this.eventPrice),
								'affiliation': this.affiliate ? this.affiliate : undefined,
								'quantity': this.amount3
							}]
						},
					});
				});
			},
			addToCartRecommendedProducts (product, index) {
				this.itemAdded = true;
				this.productName = product.title;

				this.$store.dispatch('cart/addToCart', {
					product: product.id,
					amount: this.amount4[index]
				}).then(res => {

				});
			},
			formatPrice (price) {
				numbro.setLanguage(region_code);
				return numbro(parseFloat(price)).formatCurrency();
			},
			changeVariant (pid) {
				this.product_id = pid;
			},

			transform(props) {
				Object.entries(props).forEach(([key, value]) => {
					// Adds leading zero
					const digits = value < 10 ? `0${value}` : value;
					props[key] = `${digits}`;
				});
				return props;
			},

			showModal() {
				this.modalShown = !this.modalShown;
			}
		},
		created() {
			for (let i = 0; i < this.recommended_products.length; i++) {
				this.amount4[i] = 1
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.product_id = this.variants.length ? this.variants[0].id : this.product;
				this.changeVariant(this.product_id);
				this.changeExtension(this.variants.length ? this.variants[0] : this.product);
				this.recommendedExtensions = this.variant_extensions[this.product_id]
				this.$store.dispatch('cart/setCurrent', {
					length: this.length,
					amount: this.amount,
					id: this.product_id
				});

				// Gtag
				try {
					let full_product_title = this.product_id && this.variants.length && this.variants.find(v => v.id === this.product_id)
						? this.title + ' ' + this.variants.find(v => v.id === this.product_id).title
						: this.title;
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
					window.dataLayer.push({
						'ecommerce': {
							'detail': {
								'products': [{
									'name': full_product_title,         // Name or ID is required.
									'id': this.product_id.toString(),
									'price': this.eventPrice,
								}]
							}
						}
					});
				} catch (e) {}

				try {
					let variant_name = this.product_id && this.variants.length && this.variants.find(v => v.id === this.product_id)
						? this.title + ' ' + this.variants.find(v => v.id === this.product_id).title
						: undefined;

					// Red Orbit Events
					window.dataLayer.push({'event_params': null, 'ecommerce': null});
					window.dataLayer.push({
						'event': 'RO_event_EEC',
						'event_params': {
							'gtm_name': 'EEC_view_item',
						},
						'ecommerce': {
							'currency': global.current_currency,
							'items': [{
								'item_id': this.product_id.toString(),
								'item_name': this.title,
								'item_variant': variant_name ? variant_name : undefined,
								'item_brand': 'Lupit Pole',
								'item_category': this.item.category.parent_category.title ? this.item.category.parent_category.title : this.item.category_title,
								'item_category2': this.item.category.parent_category.title ? this.item.category.title : undefined,
								'price': this.eventPrice,
								'discount': parseFloat(this.eventRegularPrice - this.eventPrice),
								'affiliation': this.affiliate ? this.affiliate : undefined
							}]
						}
					});
				} catch (e) {}
			})

			// Stick tabbed content buttons to top when scrolled past them
			const tabBar =  document.querySelector('.tab-buttons');
			if (tabBar) {
				const header = document.getElementsByTagName('header')[0];
				const top = tabBar.offsetTop;

				window.onscroll = function() {
					var y = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;

					if (y >= top) {
						header.classList.add('remove');
						tabBar.classList.add('sticky');
					} else {
						header.classList.remove('remove');
						tabBar.classList.remove('sticky');
					}
				};

				// Stick add to cart bottom when scrolled past it
				const addToCartTogglers =  document.querySelector('.product-single--togglers');
				const togglersElement = document.querySelector('.product-single--togglers-bottom');
				const togglersTop = addToCartTogglers.offsetTop;

				window.onscroll = function() {
					var y = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
					if (togglersTop && togglersElement) {
						if (y >= togglersTop) {
							togglersElement.classList.add('active');
						} else {
							togglersElement.classList.remove('active');
						}
					}
				};
			}

		}
	}

</script>
